import React, { PureComponent } from 'react';
import './Moon.css';

class Moon extends PureComponent {
	render() {
		return (
			<g className="Moon">
				<circle fill="#FFFFFF" cx="12.335" cy="11.994" r="4.881"/>
				<path className="darkside" fill="#333333" d="M12.335,7.112c-0.286,0-0.562,0.037-0.834,0.084c2.254,0.432,3.96,2.408,3.96,4.789
					c0,2.41-1.751,4.4-4.047,4.796c0.299,0.058,0.605,0.094,0.921,0.094c2.695,0,4.881-2.186,4.881-4.881S15.03,7.112,12.335,7.112z"/>
				<path className="outline" d="M15.8,8.51c-2.021-1.864-4.909-1.864-6.93,0c-2.02,1.862-1.751,5.032,0,6.931c1.862,2.02,5.032,1.751,6.931,0
					C17.819,13.578,17.552,10.409,15.8,8.51z M15.271,14.91c-1.582,1.716-4.26,1.486-5.871,0c-1.715-1.582-1.485-4.259,0-5.87
					c1.582-1.715,4.259-1.485,5.87,0C16.853,10.757,16.854,13.193,15.271,14.91z"/>
				<polygon className="star" points="17.589,5.607 17.716,5.419 17.503,5.342 17.722,5.28 17.608,5.084 17.815,5.177 17.854,4.954 17.952,5.158 
					18.126,5.012 18.071,5.232 18.298,5.232 18.114,5.364 18.287,5.51 18.062,5.494 18.101,5.717 17.938,5.559 17.825,5.755 
					17.802,5.529 	"/>
				<polygon className="star" points="5.019,18.707 4.812,18.752 4.907,18.939 4.72,18.842 4.671,19.047 4.591,18.852 4.422,18.977 4.486,18.776 
					4.276,18.764 4.454,18.651 4.301,18.506 4.51,18.535 4.486,18.325 4.628,18.481 4.744,18.306 4.752,18.516 4.954,18.456 
					4.825,18.623 	"/>
				<polygon className="star" points="19.407,10.378 19.353,10.208 19.202,10.303 19.269,10.137 19.092,10.112 19.25,10.029 19.13,9.896 19.305,9.934 
					19.298,9.755 19.407,9.896 19.518,9.755 19.511,9.934 19.687,9.896 19.565,10.029 19.724,10.112 19.547,10.137 19.614,10.303 
					19.463,10.208 	"/>
			</g>
		);
	}
}

export default Moon;
